import Box from "./Box";
import ChevronDownIcon from "../assets/chevron-down-white.svg";
import React from "react";
import Text from "./Text";

function SelectLarge({ options, handleChange, value }) {
  return (
    <Box position="relative" maxWidth={360}>
      <Box
        display={"flex"}
        backgroundColor="foreground"
        borderRadius="4px"
        height={65}
        px={22}
        alignItems="center"
        justifyContent="space-between"
      >
        <Text
          uppercase
          fontSize="14px"
          letterSpacing="2px"
          fontWeight={700}
          fontFamily="bold"
          color="background"
        >
          {options.filter((option) => option.value === value)[0].verboseName}
        </Text>
        <ChevronDownIcon />
      </Box>
      <select
        onChange={(e) => {
          handleChange(e.target.value);
        }}
        value={value}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
          opacity: 0,
        }}
      >
        {options.map((option) => {
          return (
            <option value={option.value} key={option.value}>
              {option.verboseName}
            </option>
          );
        })}
      </select>
    </Box>
  );
}

export default SelectLarge;
